<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(1 1)"><path d="M773,344a9,9,0,1,1-9-9,9,9,0,0,1,9,9Zm0,0" transform="translate(-755 -335)" fill="#f0f0f0"/><path d="M772.44,474.827a9.032,9.032,0,0,0,0-6.261H755.56a9.033,9.033,0,0,0,0,6.261l8.44.783Zm0,0" transform="translate(-755 -462.696)" fill="#0052b4"/><path d="M776.178,616.9a9,9,0,0,0,8.44-5.87h-16.88a9,9,0,0,0,8.44,5.87Zm0,0" transform="translate(-767.178 -598.905)" fill="#d80027"/><g fill="none" stroke="#e4e4e4" stroke-width="1"><circle cx="9" cy="9" r="9" stroke="none"/><circle cx="9" cy="9" r="9.5" fill="none"/></g></g></svg>
</template>

<script>
  export default {
    name: 'ru-RU',
  };
</script>
